import cn from 'classnames';
import type React from 'react';
import { useContext, useEffect } from 'react';
import gtag from '../analytics/gtag';
import { TrackingContext } from '../generic/TrackingContext';
import useBooleanState from '../utils/useBooleanState';
import * as style from './Expandable.module.css';
import ExpandButton from './ExpandButton';

export interface Props {
    title: string;
    iconPlacement?: 'left' | 'right';
    className?: string;
    isExpanded?: boolean;
    onClickHeading?(expanded: boolean): void;
}

export default function Expandable({
    children,
    title,
    className = '',
    iconPlacement = 'right',
    isExpanded = false,
    onClickHeading,
}: React.PropsWithChildren<Props>) {
    const { context } = useContext(TrackingContext);
    const [expanded, setExpanded] = useBooleanState(isExpanded);

    useEffect(() => {
        setExpanded(isExpanded);
    }, [isExpanded]);

    const toggleExpand = () => {
        setExpanded.toggle();
        onClickHeading?.(!expanded);
        gtag('event', 'expandable', {
            context,
            link_text: title,
        });
    };

    return (
        <div className={cn(style.expandable, className)}>
            <button aria-expanded={expanded} className={cn(style.expandableHeader, style[iconPlacement])} onClick={toggleExpand}>
                <span className={style.expandableTitle}>{title}</span>
                <ExpandButton expanded={expanded} />
            </button>
            {expanded && children}
        </div>
    );
}
